import { defineStore } from 'pinia';
import { localCache } from "../../utils/cache";

interface IAuthState {
	role : string
}

const useAuthStore = defineStore('auth', {
	state: () : IAuthState => ({
		role: ''
	}),
	actions: {
		changeLoginRole(role : string) {
			this.role = role
		},
		initFromStorage() {
			const role = localCache.getLoginRole()
			if (role) {
				this.role = role
			} else {
				this.role = ''
			}
		}

	}
});

export default useAuthStore;